
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/product/[id]",
      function () {
        return require("private-next-pages/catalog/product/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/product/[id]"])
      });
    }
  